import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./balanceHours.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getBalanceHoursFlow(action: actions.GetBalanceHoursAction): SagaIterator {
  try {
    const { id, params } = action.payload
    const response = yield call(api.getBalanceHours, id, params)
    yield put(actions.getBalanceHoursSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getBalanceHoursFail(e))
    yield call(handleError, { error: e })
  }
}

export function* getEstimatedBalanceHoursFlow(action: actions.GetBalanceHoursAction): SagaIterator {
  try {
    const { id, params } = action.payload
    const response = yield call(api.getBalanceHours, id, params)
    yield put(actions.getEstimatedBalanceHoursSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getEstimatedBalanceHoursFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* balanceHoursSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getBalanceHoursFlow)
  yield takeLatest(actions.Types.GET_ESTIMATED, getEstimatedBalanceHoursFlow)
}
